import { gsap } from 'gsap';

export default class AscendingNumber {
    constructor() {
        this.ascender = document.querySelectorAll('.ascending__number');
        this.init();

        console.log('test1234');
        
    }

    init() {
        this.ascender.forEach((elem, i) => {

            let ascendingNumber = {
                value: 0,
                end: parseInt(elem.getAttribute('data-value')),
                symbol: elem.getAttribute('data-symbol')
            };

            elem.innerText = '0';

            gsap.to( ascendingNumber, { // selector text, Array, or object
                duration: 5, // seconds
                value: ascendingNumber.end,
                delay: 0.5 * i,
                roundProps: 'value',
                ease: "power2.inOut",
                overwrite: "auto", // default is false
                scrollTrigger: elem,
                onUpdate: () => {
                    elem.innerText = ascendingNumber.value;
                },
                onComplete: () => {
                    elem.innerText = ascendingNumber.end + ascendingNumber.symbol + 'tara is kewl';
                }
            });
        });
    }
}